import * as InstanceType from "../ConditionTypes";
import { ConditionType, type IVehicle } from "..";
import type { ICondition, IConditionDto } from "./ICondition";
import { cond } from "lodash";

export class Conditions extends Array<ICondition>
{

    /**
     * Maps the condition type to specialised condition instance types.
     * A specialised instance will be created for each condition DTO based
     * on its type
     */
    private conditionMap = new Map<ConditionType, any>( [
        [ ConditionType.Recall, InstanceType.RecallCondition ],
        [ ConditionType.Rego, InstanceType.RegoCondition ],
        [ ConditionType.Service, InstanceType.ServiceCondition ],
        [ ConditionType.Tyres, InstanceType.TyreCondition ],
        [ ConditionType.Brakes, InstanceType.BrakesCondition ],
        [ ConditionType.Battery, InstanceType.BatteryCondition ],
        [ ConditionType.WiperBlades, InstanceType.WiperBladeCondition ],
        [ ConditionType.Wash, InstanceType.WashCondition ],
    ] );

    // Prevents .filter() method from creating new instances of the array types
    static get [ Symbol.species ]()
    {
        return Array;
    }

    private vehicle: IVehicle;

    constructor( vehicle: IVehicle, conditions: IConditionDto[] )
    {

        super();
        this.vehicle = vehicle;
    

        // Create a specialised instance type for the condition DTO's
        conditions.forEach( c =>
        {
            const type = this.conditionMap.get( c.type );
            if( type == null ) return;
            this.push( new type( vehicle, c ) as typeof type );
        } );

        this.sort( ( a, b ) => a.ordinal - b.ordinal );
        
    }

    /**
     * Gets the condition from the array using the passed in specialized type
     * @param cls 
     * @returns 
     */
    get<TCondition extends ICondition>( cls: new( vehicle: IVehicle, dto: any ) => TCondition ): TCondition
    {
        return this.find( (value): value is TCondition => value instanceof cls )!;
    }

}

